<template>
  <v-container fluid class="user-list mt-3">
    <v-row class="ma-0">
      <v-col cols="12">
        <h1>Vendors page</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "VendorsList"
}
</script>

<style scoped>

</style>